import {FirestoreTimestamp} from '../_other/firestore/firestoreTimestampSchema';
import {UserDb} from './userDbSchema';
import {UserWrite} from './userWriteSchema';

/**
 * Map client write payload to full user document for create.
 * @param write
 * @param timestamp Used for createdAt and lastLogin
 */
export function mapUserWriteToDb(write: UserWrite, timestamp: FirestoreTimestamp): UserDb {
  return {
    ...write,
    createdAt: timestamp,
    lastLogin: timestamp,
    roles: [],
    disableAnimation: false,
    groupIds: [],
    inviteToGroupIds: [],
    selectedModules: [],
    currentStreak: 0,
    highestStreak: 0,
  };
}
